import { BlindConfigService } from "../Common/BlindConfigurations/BlindConfigService";
import { ISrp30ConfigService } from "./ISrp30ConfigService";

export class Srp30ConfigService extends BlindConfigService implements ISrp30ConfigService {
    public static readonly ServiceName: string = "Srp30ConfigService";

    constructor() {
        super();
    }

    GetServiceName(): string {
        return Srp30ConfigService.ServiceName;
    }
}